import Button from '../../../Core/widget/Button.js';
import RecurrenceLegend from '../../data/util/recurrence/RecurrenceLegend.js';

/**
 * @module Scheduler/view/recurrence/RecurrenceLegendButton
 */

/**
 * A button which displays the associated {@link #property-recurrence} info in a human-readable form.
 * @extends Core/widget/Button
 * @classtype recurrencelegendbutton
 */
export default class RecurrenceLegendButton extends Button {

    static $name = 'RecurrenceLegendButton';

    // Factoryable type name
    static type = 'recurrencelegendbutton';

    static configurable = {
        localizableProperties : [],
        /**
         * Sets / gets the recurrence to display description for.
         * @member {Scheduler.model.RecurrenceModel} recurrence
         */
        recurrence            : null,
        eventStartDate        : null
    };

    updateRecurrence(recurrence) {
        this.updateLegend();
    }

    updateEventStartDate(eventStartDate) {
        this.updateLegend();
    }

    updateLegend() {
        const { recurrence } = this;

        this.text = recurrence ? RecurrenceLegend.getLegend(recurrence, this.eventStartDate) : '';
    }

    onLocaleChange() {
        // on locale switch we update the button text to use proper language
        this.updateLegend();
    }

    updateLocalization() {
        this.onLocaleChange();
        super.updateLocalization();
    }
}

// Register this widget type with its Factory
RecurrenceLegendButton.initClass();
